import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { BrandProvider } from "./contexts/BrandProvider";
import { useAuthStore } from "./store/auth";
import { queryClient } from "./lib/queryClient";
import { installPreloadErrorHandler } from "./lib/chunkReload";
import "./lib/i18n";
import "./index.css";

// Phase A: a brand can be previewed on the platform domain via `?dealer=<slug>`.
// Host-based resolution (Phase B) needs no slug; the param is simply absent.
const dealerSlug =
  new URLSearchParams(window.location.search).get("dealer") ?? undefined;

// Restore auth state from localStorage before rendering, so ProtectedRoute
// reads the correct isAuthenticated flag on hard refresh. Skipped on public,
// intentionally-unauthenticated routes (e.g. the customer tracking page) so a
// stale token never triggers an /auth/me 401 that would bounce a recipient to
// /login.
if (!window.location.pathname.startsWith("/track/")) {
  useAuthStore.getState().initFromStorage();
}

// BUG-745: a failed chunk preload after a deploy reloads the page once.
installPreloadErrorHandler();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrandProvider dealerSlug={dealerSlug}>
          <App />
        </BrandProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
);
